import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractEditPage, PageContentMode} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {MetaTagType} from "../../../catalogue/meta-tag/meta-tag.data";
import {KitchenDisplayEntityModel} from "../kitchen-display-entity.model";
import {KvdDisplayType} from "../../order_processor/order-processor.data";

@Component({
    selector: "wbo-kitchen-display-edit-page",
    templateUrl: "./kitchen-display-edit-page.component.html",
    styleUrls: ["./kitchen-display-edit-page.component.scss"],
    providers: [
        provideEntityModel(KitchenDisplayEntityModel)
    ]
})
export class KitchenDisplayEditPageComponent extends AbstractEditPage {

    KvdDisplayType = KvdDisplayType;
    MetaTagType = MetaTagType;

    constructor(public model: KitchenDisplayEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.pageState.contentMode = PageContentMode.DETAILED;
    }

    get notificationMessage(): string {
        return this.model.data.notificationDescription && this.model.data.notificationLocation ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReadyFromLocation"
            : this.model.data.notificationDescription ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReady"
                : this.model.data.notificationLocation ? "wbo.order-action-display.edit.message.orderReady.orderReadyFromLocation"
                    : "wbo.order-action-display.edit.message.orderReady.orderReady";
    }

    get productTypePlaceholder(): any {
        return this.model.data.matchNoTags ? "wbo.meta-tag.option.modifier.matchNoTags" : "wbo.order-processor.edit.option.docketSelectorType.allProducts";
    }

    changeSite(): void {
        this.model.data.webTerminalIds = [];
    }

    outletsChanged(): void {
        if (this.model.data.outlets.length) {
            this.model.data.terminals = [];
            this.model.data.webTerminalIds = [];
        }
    }

    terminalsChanged(): void {
        if (this.model.data.terminals.length) {
            this.model.data.outlets = [];
            this.model.data.webTerminalIds = [];
        }
    }

    webTerminalsChanged(): void {
        if (this.model.data.webTerminalIds.length) {
            this.model.data.outlets = [];
            this.model.data.terminals = [];
        }
    }
}
